import { render, staticRenderFns } from "./EFDTRARecords.vue?vue&type=template&id=68691474&"
import script from "./EFDTRARecords.vue?vue&type=script&lang=js&"
export * from "./EFDTRARecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports